import { LoadableLazy } from '@confluence/loadable';
export { isEligibleForFeedbackAnalysisDiscovery } from '../src/rovo/FeedbackAnalysisDialog.tsx';
export const LazyFeedbackAnalysisDiscoveryDialog = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-FeedbackAnalysisDiscoveryDialog" */ '../src/rovo/FeedbackAnalysisDialog.tsx'
			)
		).FeedbackAnalysisDialog,
});
